import { createAction, props } from '@ngrx/store';
import { BeneficialOwnerPEP } from '../../pep-list/pep-list.interface';

import { SingleCompany, CompanyPitch, SelfPublishTag } from '../companies.interface';
import { ObjectId } from '../../../core/interfaces/shared.interface';

export const setCompany = createAction('[Company Component] Set Company', props<{ company: SingleCompany }>());

export const setCompanyPitches = createAction('[Company Component] Set Company Pitches', props<{ pitches: CompanyPitch[] }>());

export const setCompanyPepChecks = createAction('[Company Component] Set Company Pep Checks', props<{ pepChecks: BeneficialOwnerPEP[] }>());

export const deleteFile = createAction('[Company Component] Delete File', props<{ id: string }>());

export const resetCompanyState = createAction('[Company Component] Reset Company State');

export const updateCompany = createAction('[Company Component] Update Company', props<{ company: Partial<SingleCompany> }>());

export const request = {
  patchCompany: createAction('[Request/Api Companies] Patch Company', props<{ id: SingleCompany['id']; tags: SelfPublishTag['id'][] }>()),
  loadCompany: createAction('[Request/Api Company] Load Company', props<{ id: string }>()),
  loadCompanyPepChecks: createAction('[Request/Api Company] load Company Pep Checks', props<{ id: SingleCompany['id'] }>()),
  createManualPepCheck: createAction(
    '[Request/Api Company] Create Company Pep Check',
    props<{ companyId: SingleCompany['id']; updateSet: { pepCheck: ObjectId; status: string; comment: string }[] }>()
  )
};
